import { render, staticRenderFns } from "./House.vue?vue&type=template&id=9bb13994&scoped=true&"
import script from "./House.vue?vue&type=script&lang=js&"
export * from "./House.vue?vue&type=script&lang=js&"
import style0 from "./House.vue?vue&type=style&index=0&id=9bb13994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb13994",
  null
  
)

export default component.exports